import { ref } from 'vue'
import { listSupportTickets } from '@/api/support'
import type { SupportTicket, SupportTicketFilter } from '@/types/support'
import type { PaginationMeta } from '@/types/finance'

export function useSupportTickets(organisationId: number) {
  const tickets = ref<SupportTicket[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)
  const meta = ref<PaginationMeta | null>(null)

  async function fetch(filter: SupportTicketFilter = 'all', page = 1): Promise<void> {
    loading.value = true
    error.value = null
    try {
      const params: { filter?: SupportTicketFilter; page?: number } = { page }
      if (filter && filter !== 'all') params.filter = filter
      const result = await listSupportTickets(organisationId, params)
      tickets.value = result.data
      meta.value = result.meta
    } catch {
      error.value = 'support.list.error'
    } finally {
      loading.value = false
    }
  }

  return { tickets, loading, error, meta, fetch }
}
